const ENTRY_KIND = {
  EVENT: 'EVENT',
  MILESTONE: 'MILESTONE'
};

const PLACEMENT_BLOCK = {
  HEADER: 'HEADER',
  CONTENT: 'CONTENT',
  FOOTER: 'FOOTER'
};

const PLACEMENT_BLOCKS = Object.values(PLACEMENT_BLOCK);

const ACTIONS = {
  CREATION: 'CREATION',
  ADDITION: 'ADDITION',
  DELETION: 'DELETION',
  NAME_UPDATE: 'NAME_UPDATE',
  COMPOSITION_UPDATE: 'COMPOSITION_UPDATE',
  CONDITIONS_UPDATE: 'CONDITIONS_UPDATE',
  CONTENT_UPDATE: 'CONTENT_UPDATE',
  DUPLICATED_FROM: 'DUPLICATED_FROM'
};

const TARGET_TYPES = {
  DOCUMENT: 'DOCUMENT',
  SECTION: 'SECTION',
  WIDGET: 'WIDGET'
};

const MILESTONE_TYPES = {
  HISTORY_START: 'HISTORY_START',
  OFFER_VERSION_CREATED: 'OFFER_VERSION_CREATED'
};

const ACTION_LABELS_FR = {
  'création': [ACTIONS.CREATION],
  'ajout': [ACTIONS.ADDITION],
  'suppression': [ACTIONS.DELETION],
  'modification du nom': [ACTIONS.NAME_UPDATE],
  'modification de la composition': [ACTIONS.COMPOSITION_UPDATE],
  'modification des conditions': [ACTIONS.CONDITIONS_UPDATE],
  'modification du contenu': [ACTIONS.CONTENT_UPDATE],
  'dupliqué depuis': [ACTIONS.DUPLICATED_FROM]
};

const HISTORY_PERIOD = {
  ALL: 'ALL',
  CURRENT_MONTH: 'CURRENT_MONTH',
  LAST_3_MONTHS: 'LAST_3_MONTHS',
  LAST_6_MONTHS: 'LAST_6_MONTHS',
  LAST_12_MONTHS: 'LAST_12_MONTHS'
};

const BLOCK_MAP = {
  header: 'HEADER', widgets: 'CONTENT', footer: 'FOOTER' 
};

const BLOCK_KEYS = Object.keys(BLOCK_MAP);

module.exports = {
  ENTRY_KIND,
  PLACEMENT_BLOCK,
  PLACEMENT_BLOCKS,
  ACTIONS,
  TARGET_TYPES,
  MILESTONE_TYPES,
  ACTION_LABELS_FR,
  HISTORY_PERIOD,
  BLOCK_MAP,
  BLOCK_KEYS
};
